import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { InputLabel, TextField } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  //   border: "2px solid #000",
  boxShadow: 24,
  borderRadius: "15px",
};

function UploadDocs({ open, handleClose, handleAddObject }) {
  const [doc, setDoc] = React.useState({
    url: null,
    type: null,
  });
  const [error, setError] = React.useState({});
  const formValue = new FormData();
  const [flag, setFlag] = React.useState(false);

  const documentURLHandler = (e) => {
    setFlag(true);
    formValue.append("file", e);
    const url = "https://retailorder.ayekart.com/api/mitra-merchant/doc-upload";
    const finalURL = url.replace("https://retailorder.ayekart.com", "");
    axios
      .post("/upload/mitra-merchant/doc-upload", formValue)
      .then((response) => {
        setDoc({
          ...doc,
          url: response?.data?.file_location,
        });
        setFlag(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //=============================== doc submit handler==============================
  const submitHandler = (e) => {
    e.preventDefault();
    if (doc?.url && doc.type) {
      handleAddObject(doc);
      handleClose();
      setDoc({ url: "", type: "" });
      setError();
    } else {
      let err = {};
      if (!doc?.url) {
        err.url = "Please select file";
      }
      // if (!doc?.type) {
      //   err.type = "Please entre type";
      // }
      setError(err);
    }
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="flex justify-between p-2">
            {" "}
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Upload Documents
            </Typography>
            <Button sx={{ color: "red" }} onClick={() => handleClose()}>
              <CancelIcon />
            </Button>
          </div>
          <div className="border-2 border-gray-600"></div>
          <div className="mt-2 ps-3 pe-3">
            <InputLabel sx={{ color: "#000" }}>
              Type <span style={{ color: "red" }}>*</span>
            </InputLabel>
            <TextField
              size="small"
              fullWidth
              onChange={(e) =>
                setDoc({
                  ...doc,
                  type: e.target.value,
                })
              }
            />
          </div>
          <div className="pt-2 ps-3 pe-3 ">
            <InputLabel sx={{ color: "#000" }}>
              Document <span style={{ color: "red" }}>*</span>
            </InputLabel>
            <TextField
              size="small"
              fullWidth
              type="file"
              onChange={(e) => documentURLHandler(e.target.files[0])}
            />
          </div>
          {flag ? (
            "wait"
          ) : (
            <div className="flex justify-end p-3">
              <Button
                variant="contained"
                sx={{ backgroundColor: "#087C10" }}
                onClick={submitHandler}
              >
                Add
              </Button>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default UploadDocs;
